"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VerticalNavMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _VerticalNavList = require("../../components/VerticalNavList/VerticalNavList.styles");
/** @class VerticalNavMixin */
/** @method */

var VerticalNavMixin = function VerticalNavMixin(props) {
  var border = props.border,
    background = props.background,
    navElevation = props.navElevation;
  return (0, _styledToken.default)({
    boxShadow: 'VerticalNav.boxShadow',
    backgroundColor: 'VerticalNav.backgroundColor',
    borderColor: 'VerticalNav.borderColor',
    borderRadius: 'VerticalNav.borderRadius'
  }, function (_ref) {
    var boxShadow = _ref.boxShadow,
      backgroundColor = _ref.backgroundColor,
      borderColor = _ref.borderColor,
      borderRadius = _ref.borderRadius;
    return (0, _styledComponents.css)(["box-sizing:border-box;display:flex;flex-direction:column;background-color:", ";box-shadow:", ";", " ", " ", "{> *{&:first-child{border-top-left-radius:", "px;}&:last-child{border-bottom-left-radius:", "px;}}}"], background ? backgroundColor : 'transparent', navElevation ? boxShadow : 'none', background && "border-radius: " + borderRadius + "px;", border && "border: 1px solid " + borderColor + ";", _VerticalNavList.StyledVerticalNavList, background ? borderRadius : 0, background ? borderRadius : 0);
  });
};
exports.VerticalNavMixin = VerticalNavMixin;